import { spacing, TmElement } from '@thiememeulenhoff/lit-sdk';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tagName } from '../../helpers';

const tag = tagName('toc');

@customElement(tag)
export class TocComponent extends TmElement {
  static override styles = [
    css`
      :host {
        display: flex;
        flex-direction: column;
      }

      :host([secondaryColor]) {
        gap: ${spacing(100)};
      }

      ::slotted(a-toc-item:first-child) {
        padding-block-start: 0;
      }

      ::slotted(a-toc-item:last-child) {
        padding-block-end: 0;
      }
    `,
  ];

  @property({ type: Boolean, reflect: true })
  secondaryColor = false;

  override render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-toc': TocComponent;
  }
}
